// ------------------------
// 商品詳細ページ・すべて見る
// ------------------------

// ------------------------
// 商品詳細ページ・すべて見る
// ------------------------
/*
$(window).on('load',function() {

    function checkOverflow() {
      $readMore1 = $('.read_more_wrapper').eq(1);
      console.log($readMore1.html());
      var $description1 = $readMore1.find('.product__description');
      var $toggleText1 = $readMore1.find('.toggle_text');
      var $readMoreContent1 = $readMore1.find('.read_more_content');    

      if ($description1.scrollHeight > 80) {
          $toggleText1.show(); // 溢れている場合は表示
          $readMoreContent1.removeClass('gradient_hidden');
          $readMoreContent1.addClass('read_more_content_gradient');
      } else {
          $toggleText1.hide(); // 溢れていない場合は非表示
          $readMoreContent1.addClass('gradient_hidden');
          $readMoreContent1.removeClass('read_more_content_gradient');
      }

      $readMore2 = $('.read_more_wrapper:nth-child(2)');
      var $description2 = $readMore2.find('.product__description');
      var $toggleText2 = $readMore2.find('.toggle_text');
      var $readMoreContent2 = $readMore2.find('.read_more_content');    
      if ($description2.scrollHeight > 80) {
          $toggleText2.show(); // 溢れている場合は表示
          $readMoreContent2.removeClass('gradient_hidden');
          $readMoreContent2.addClass('read_more_content_gradient');
      } else {
          $toggleText2.hide(); // 溢れていない場合は非表示
          $readMoreContent2.addClass('gradient_hidden');
          $readMoreContent2.removeClass('read_more_content_gradient');
      }
    }
    
    // 初回チェック
    checkOverflow();

    // ウィンドウサイズが変更されたときにチェック
    $(window).on('resize', function() {
        checkOverflow();
    });

    // チェックボックスがクリックされたときの処理
    $readMoreWrapper1 = $('.read_more_wrapper:nth-child(1)');
    var $readMoreShowtext1 = $(this).find('.read_more_showtext');
    var $toggleText1 = $(this).find('.toggle_text');
    var $readMoreContent1 = $(this).find('.read_more_content');
    $readMoreShowtext1.on('change', function() {
        if ($(this).is(':checked')) {
            $toggleText1.text('元に戻す'); // テキスト変更
            $readMoreContent1.addClass('gradient_hidden');
            $readMoreContent1.removeClass('read_more_content_gradient');            
        } else {
            $toggleText1.text('すべて見る'); // テキスト変更
            checkOverflow(); // 再チェック
        }
    });

    $readMoreWrapper2 = $('.read_more_wrapper:nth-child(2)');
    var $readMoreShowtext2 = $(this).find('.read_more_showtext');
    var $toggleText2 = $(this).find('.toggle_text');
    var $readMoreContent2 = $(this).find('.read_more_content');
    $readMoreShowtext2.on('change', function() {
        if ($(this).is(':checked')) {
            $toggleText2.text('元に戻す'); // テキスト変更
            $readMoreContent2.addClass('gradient_hidden');
            $readMoreContent2.removeClass('read_more_content_gradient');            
        } else {
            $toggleText2.text('すべて見る'); // テキスト変更
            checkOverflow(); // 再チェック
        }
    });

});
*/

$(window).on('load',function() {

    function checkOverflow() {
      $('.read_more_wrapper').each(function(){
        var $description = $(this).find('.product__description');
        var $toggleText = $(this).find('.toggle_text');
        var $readMoreContent = $(this).find('.read_more_content');

        //console.log($description[0].scrollHeight);
        if ($description[0].scrollHeight > 80) {
            $toggleText.show(); // 溢れている場合は表示
            $readMoreContent.removeClass('gradient_hidden');
            $readMoreContent.addClass('read_more_content_gradient');
        } else {
            $toggleText.hide(); // 溢れていない場合は非表示
            $readMoreContent.addClass('gradient_hidden');
            $readMoreContent.removeClass('read_more_content_gradient');
        }
      });
    }
    
    // 初回チェック
    setTimeout(function(){
      checkOverflow();
    },500);

    // ウィンドウサイズが変更されたときにチェック
    // $(window).on('resize', function() {
    //     checkOverflow();
    // });

    // チェックボックスがクリックされたときの処理  
    $('.read_more_showtext').on('change', function() {
      if ($(this).is(':checked')) {
        $(this).closest('.read_more_wrapper').find('.read_more_content').removeClass('read_more_content_gradient');        
      } else {
        $(this).closest('.read_more_wrapper').find('.read_more_content').addClass('read_more_content_gradient'); 
      }
    });

/*
  
    $('.read_more_wrapper').each(function(){
      var $readMoreShowtext = $(this).find('.read_more_showtext');
      var $toggleText = $(this).find('.toggle_text');
      var $readMoreContent = $(this).find('.read_more_content');

      var readMore = (function(readMoreShowtext, toggleText, readMoreContent, $this){
        readMoreShowtext.on('change', function() {
                  console.log($this.is(':checked'));
            if ($this.is(':checked')) {
                toggleText.text('元に戻す'); // テキスト変更
                readMoreContent.addClass('gradient_hidden');
                readMoreContent.removeClass('read_more_content_gradient');
            } else {
                toggleText.text('すべて見る'); // テキスト変更
                checkOverflow(); // 再チェック
            }
        });
      })($readMoreShowtext, $toggleText, $readMoreContent, $(this));

      readMore;
    });
  */
});

